import React from 'react'
import SearchableSelect from '../SearchableSelect/SearchableSelect'
import { ILocationForPallet } from '../../../modules/API/Pallets/models/locations'
import MapPinIcon from '../../icons/IconLib/MapPinIcon'

interface Props {
  locations: ILocationForPallet[]
  value: ILocationForPallet | null
  onSelect: (location: ILocationForPallet | null) => void
  placeholder?: string
  disabled?: boolean
  readOnly?: boolean
  className?: string
}

const LocationSelector: React.FC<Props> = ({
  locations,
  value,
  onSelect,
  placeholder = 'הכנס איתור',
  disabled,
  readOnly,
  className,
}) => (
  <SearchableSelect<ILocationForPallet>
    items={locations}
    value={value}
    onSelect={onSelect}
    getKey={(l) => l.Code}
    getLabel={(l) => (l.Description ?? '').trim()}
    getSearchText={(l) => `${l.Description ?? ''} ${l.Code ?? ''}`}
    placeholder={placeholder}
    disabled={disabled}
    readOnly={readOnly}
    leadingIcon={<MapPinIcon />}
    className={className}
    emptyLabel='אין איתורים מתאימים'
  />
)

export default LocationSelector
